const SvgAIandMl1 = (props) => (
  <>
    <defs />
    <path
      d="M264 192h87.84M7.7 192h112M54 54l88 88M54 330l86-86"
      stroke="#042068"
      strokeWidth="3px"
      fill="none"
      strokeMiterlimit={10}
    />
    <circle cx={192} cy={192} r={72} stroke="#042068" strokeWidth="3px" fill="none" strokeMiterlimit={10} />
    <path
      d="M8 192c0 4.42-3.58 8-8 8s-8-3.58-8-8 3.58-8 8-8 8 3.58 8 8Z"
      stroke="#042068"
      strokeWidth="3px"
      fill="none"
      strokeMiterlimit={10}
    />
    <circle cx={48} cy={336} r={8} stroke="#042068" strokeWidth="3px" fill="none" strokeMiterlimit={10} />
    <circle cx={48} cy={48} r={8} stroke="#042068" strokeWidth="3px" fill="none" strokeMiterlimit={10} />
    <circle cx={352} cy={192} r={8} fill="#0062ff" strokeWidth={0} />
    <circle cx={352} cy={192} r={24} stroke="#001d6c" fill="none" strokeMiterlimit={10} />
  </>
);

export default SvgAIandMl1;
